/*
 * Copyright (c) 2022. American Express Company
 */

// theirs
import React, { Component, ReactComponentElement } from 'react';
import _ from 'lodash';

// ours
import { TooltipPlacement } from 'src/types/tooltip-placement.enum';
import { SectionHeaderViewModel } from 'src/types/view-models/section-header.view.model';

// styles
import styles from './SectionHeader.module.scss';
import Typography from '../typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';
import MoreInfoTooltip from 'src/components/more-info-tooltip/MoreInfoTooltip';

export default class SectionHeader extends Component<SectionHeaderViewModel> {
    public override render(): ReactComponentElement<any> {
        const dataCy: string = _.camelCase(this.props.title) + 'SectionHeader';
        return (
            <div className={styles.sectionHeader} data-cy={dataCy}>
                <div className={styles.left}>
                    <div className={styles.sectionNameAndIcon}>
                        <Typography variant={TypographyVariants.HEADING_XS} className={styles.title}>
                            {this.props.title}
                        </Typography>
                        {this.props.tooltipDescription && (
                            <MoreInfoTooltip
                                body={this.props.tooltipDescription}
                                placement={TooltipPlacement.BOTTOM}
                                width="260px"
                                buttonAriaLabel={this.props.title}
                            />
                        )}
                    </div>
                    {this.props.subtitle && (
                        <Typography variant={TypographyVariants.SUBTEXT}>{this.props.subtitle}</Typography>
                    )}
                </div>
                <div className={styles.right}>
                    <Typography className={styles.value} variant={TypographyVariants.HEADING_S}>
                        {this.props.value}
                    </Typography>
                </div>
            </div>
        );
    }
}
